/* ==========================================================================
   WAVE HAWAII · Warenkorb-Drawer (Fusion Agency, 30.10.2026)
   1. Verlauf über der Produktliste, solange man weiter nach unten scrollen kann
   2. Klick auf eine Geschenk-Stufe öffnet das Geschenk-Fenster der App (Qikify)
   Eingebunden in sections/cart-drawer.liquid, Gestaltung in assets/wh-cart.css.
   ========================================================================== */
(() => {
  if (window.whCartInit) return;
  window.whCartInit = true;

  /* ---------- 1. Verlauf ---------- */
  const bindFade = (drawer) => {
    const scroller = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part~="body"]');
    if (!scroller || scroller.dataset.whFade) return;
    scroller.dataset.whFade = '1';

    const update = () => {
      const more = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight > 6;
      drawer.classList.toggle('wh-cart--more', more);
    };

    const later = () => { requestAnimationFrame(update); setTimeout(update, 400); };
    scroller.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(later).observe(scroller);
    // Inhalt neu gerendert (Mengen, Hinzufügen) oder Warenkorb geöffnet
    new MutationObserver(later).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    later();
  };

  /* ---------- 2. Klick auf Geschenk-Stufe ---------- */
  const normalize = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9äöüß]/g, '');

  const openAppGift = (step) => {
    const drawer = step.closest('cart-drawer');
    const milestones = [...(drawer || document).querySelectorAll('.qbk-order-goal__milestone')];
    if (!milestones.length) return;

    const wanted = normalize(step.dataset.whGoalTitle);
    let target = milestones.find((m) => normalize(m.querySelector('.qbk-order-goal__title')?.textContent) === wanted);

    // Fallback: gleiche Reihenfolge wie die Geschenk-Stufen der eigenen Leiste
    if (!target) {
      const giftSteps = [...drawer.querySelectorAll('.wh-cart-goal__step--gift')];
      target = milestones[giftSteps.indexOf(step)] || milestones[milestones.length - 1];
    }

    (target.querySelector('.qbk-order-goal__icon') || target).click();
  };

  document.addEventListener('click', (event) => {
    const step = event.target.closest('.wh-cart-goal__step--gift');
    if (step) openAppGift(step);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const step = event.target.closest && event.target.closest('.wh-cart-goal__step--gift');
    if (!step) return;
    event.preventDefault();
    openAppGift(step);
  });

  /* ---------- 3. Größe in den Ergänzungen: Schnellansicht mit dieser Größe öffnen ---------- */
  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-wh-qb-variant]');
    if (!pill) return;
    event.preventDefault();
    const modal = document.getElementById(pill.dataset.whQbModal);
    if (!modal || typeof modal.show !== 'function') return;
    modal.setAttribute('handle', `${pill.dataset.whQbHandle}?variant=${pill.dataset.whQbVariant}`);
    modal.show();
  });

  const start = () => {
    document.querySelectorAll('cart-drawer').forEach(bindFade);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  customElements.whenDefined('cart-drawer').then(start);
})();

/* ==========================================================================
   WAVE HAWAII · Klaviyo-Teaser (10 %) und Chat-Button über der Sticky-Add-to-Cart-Leiste (31.10.2026)
   Ist die Leiste unten eingeblendet, sitzen beide auf gleicher Höhe 5 px über ihr.
   Ist sie ausgeblendet (oder oben, Desktop), gilt die ursprüngliche Position.
   ========================================================================== */
(() => {
  if (window.whStickyOffsetInit) return;
  window.whStickyOffsetInit = true;
  const GAP = 5;
  const BASE = 20; /* Grundposition: gleiche Höhe wie der Klaviyo-Teaser (20 px Abstand zum Rand) */
  const root = document.documentElement;

  const update = () => {
    const bar = document.querySelector('product-sticky-bar');
    let h = 0;
    if (bar && bar.classList.contains('is-visible')) {
      const r = bar.getBoundingClientRect();
      if (r.height > 0 && r.bottom >= window.innerHeight - 2) h = Math.round(r.height);
    }
    root.style.setProperty('--wh-sticky-bar-h', h + 'px');
    root.style.setProperty('--wh-chat-bottom', (h > 0 ? h + GAP : BASE) + 'px');
    root.classList.toggle('wh-sticky-bar-on', h > 0);
  };

  /* Chat (Voiceflow) liegt im Shadow DOM: Stil einmalig hineingeben, Position über die Variable --wh-chat-bottom */
  const styleChat = () => {
    const host = document.getElementById('voiceflow-chat');
    const sr = host && host.shadowRoot;
    const launcher = sr && sr.querySelector('.vfrc-launcher__container');
    if (!launcher) return false;
    if (sr.querySelector('#wh-sticky-offset')) return true;
    const st = document.createElement('style');
    st.id = 'wh-sticky-offset';
    st.textContent = '.vfrc-launcher__container{bottom:var(--wh-chat-bottom,' + BASE + 'px)!important;transition:bottom .25s ease}';
    sr.appendChild(st);
    update();
    return true;
  };

  const start = () => {
    const bar = document.querySelector('product-sticky-bar');
    if (bar) new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class', 'hidden'] });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('scroll', update, { passive: true });
    update();
    let tries = 0;
    const t = setInterval(() => { if (styleChat() || ++tries > 40) clearInterval(t); }, 500);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
